import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';

import { latLng, Marker, marker, tileLayer, Map, point, LatLngBounds, divIcon } from 'leaflet';
import { Activo } from '../../../core/modelos/activo';

@Component({
    selector: 'fuse-mini-mapa',
    templateUrl: './mini-mapa.component.html',
    styleUrls: ['./mini-mapa.component.scss']
})
export class MiniMapaComponent implements OnInit, OnChanges {

    @Input() activo: any;

    mapa: Map;

    // Variable que contendrá los marcadores tipados para añadir al mapa
    marker: Marker;

    // Puntos (2) para centrar el mapa
    bounds: any;

    Mapbox = tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: 'mapbox/light-v10',
      detectRetina: true,
      maxZoom: 18,
      minZoom: 3,
      accessToken: 'pk.eyJ1IjoiYmltdXgiLCJhIjoiY2swbmozcndlMDBjeDNuczNscTZzaXEwYyJ9.oMM71W-skMU6IN0XUZJzGQ'
    });

    // Layers control object with our two base layers and the three overlay layers
    layersControl = {
        baseLayers: {
            'Open Street Map': this.Mapbox
        }
    };

    // Values to bind to Leaflet Directive
    options = {};

    constructor() { }

    // Fijo los límites del mapa

    artico = latLng([84.986814, -179.913355]);
    antartico = latLng([-84.984656, 179.869185]);
    limites = new LatLngBounds(this.artico, this.antartico);

    ngOnInit() {
        this.crearMapa();
    }
    formatearLatLong(activo: Activo): L.LatLngExpression{
        // Metodo que recibe un activo y retorna el array con la latitud y la longitud
        return [activo.latitud, activo.longitud];
    }

    crearMapa() {
        this.options = {
            layers: [this.Mapbox],
            zoom: 12,
            center: this.formatearLatLong(this.activo),
            attributionControl: false
        };

        // Creo marcador

        this.marker = marker(this.formatearLatLong(this.activo), {
            icon: divIcon({
                html: '<i class="fas fa-map-marker"></i>',
                iconAnchor: [9, 25],
                popupAnchor: [4, -15]
            })
        });

        // Fijo coordenadas de 2 puntos iniciales, si existen, si no, pongo el mismo 2 veces

        this.bounds = new LatLngBounds(this.formatearLatLong(this.activo), this.formatearLatLong(this.activo));
    }

    onMapReady(map: Map) {

        this.mapa = map;

        // Señalo los límites del mapa

        map.setMaxBounds(this.limites);

        // Fijo el mapa encuadrando los marcadores

        setTimeout(() => {

            map.fitBounds(this.bounds, {
                padding: point(24, 24),
                maxZoom: 16
            });

        }, 500);

    }

    ngOnChanges(changes: SimpleChanges) {

        if (!changes.activo.firstChange) {

            // Cuando estamos en Dashboard y seleccionamos otro activo de la lista.
            this.crearMapa();

            this.mapa.fitBounds(this.bounds, {
                padding: point(24, 24),
                maxZoom: 16
            });

            this.mapa.invalidateSize()
        }

        setTimeout(() => {
          this.mapa.invalidateSize()

          this.mapa.fitBounds(this.bounds, {
              padding: point(24, 24),
              maxZoom: 16
          });

        }, 1000);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/components/mini-mapa/mini-mapa.component.ts